export const USER_STATUS = {
  DELETED: 'DELETED',
  ACTIVE: 'ACTIVE',
} as const;
